import { BodyPartFilterTree } from './body-part-filter-tree'
import styles from './body-part-filter.module.scss'
import { BodyPartFilterModel, bodyPartUtil } from './body-part-util'
import { useFilterContext } from '../../../context/filter-context'
import { SidebarFilterSection } from '../sidebar-filter-section'
import React from 'react'
import { useBodyParts } from 'src/hook/use-body-parts'

export const BodyPartFilter = (): React.ReactElement => {
  const { workoutFilter, setFilterEntry } = useFilterContext()
  const { bodyParts, rootDepth } = useBodyParts()

  const handleOnBodyPartsToggle = (id: string): void => {
    const prevState = workoutFilter?.bodyParts ?? []

    const selectedBodyParts = bodyPartUtil.getSelectedFilters(bodyParts, prevState, id)

    const selectedPartIds = Object.entries(selectedBodyParts)
      .filter(([_, selected]) => selected)
      .map(([id, _]) => id)

    setFilterEntry('bodyParts', selectedPartIds)
  }

  const renderBodyPartRoot = (root: BodyPartFilterModel, additionalClass?: string): React.ReactElement => {
    return (
      <div className={`${styles.treeContainer} ${additionalClass}`}>
        <BodyPartFilterTree
          root={root}
          selectedParts={workoutFilter?.bodyParts ?? []}
          handleOnToggle={handleOnBodyPartsToggle}
          treeDepth={rootDepth[root.id]}
        />
      </div>
    )
  }

  return <SidebarFilterSection title={'Body Part'} items={bodyParts} lineLimit={1} renderItem={renderBodyPartRoot} />
}
